import { render, staticRenderFns } from "./SensorTypeLegend.vue?vue&type=template&id=4c51ba26&scoped=true&"
import script from "./SensorTypeLegend.vue?vue&type=script&lang=js&"
export * from "./SensorTypeLegend.vue?vue&type=script&lang=js&"
import style0 from "./SensorTypeLegend.vue?vue&type=style&index=0&id=4c51ba26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51ba26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c51ba26')) {
      api.createRecord('4c51ba26', component.options)
    } else {
      api.reload('4c51ba26', component.options)
    }
    module.hot.accept("./SensorTypeLegend.vue?vue&type=template&id=4c51ba26&scoped=true&", function () {
      api.rerender('4c51ba26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/SensorTypeLegend.vue"
export default component.exports